import React from 'react'
import { Outlet } from "react-router-dom"
import doku from '../../assets/img/bd-doku2.png'

const AuthLayout = () => {
    return (
        <>
            <div className='flex min-h-screen bg-white'>
                <div className='relative flex flex-1 flex-col justify-center px-6 py-12 lg:w-2/5 lg:flex-none' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
                    <Outlet/>
                </div>
                <div className='bg-slate-200 relative hidden w-0 flex-1 items-center justify-center lg:flex lg:w-3/5'>
                    <img className='w-full h-screen object-cover' src='https://www.odu.edu.tr/dist/images/LoginPageImages/odukampus.jpg' alt='ODÜ Kampüs' />
                </div>
            </div>
            {/* <Outlet /> */}
        </>
    );
}

export default AuthLayout;
